// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ActionButtons Styles */
.action-column {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 280px;
    min-width: 280px;
    padding: 4px;
}

.action-row {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-start;
    width: 100%;
}

.info-row {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #64748b;
}

.info-label {
    font-size: 12px;
    color: #94a3b8;
}

.info-value {
    font-size: 12px;
    color: #1e293b;
}

.action-link {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 1px;
    border: none;
    background-color: transparent;
    color: #475569;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.action-link:hover {
    background-color: #f1f5f9;
}

.menu-wrapper {
    position: relative;
    display: inline-block;
}

.menu-button {
    padding: 4px 8px;
    border: none;
    background-color: transparent;
    color: #64748b;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    transition: color 0.2s ease;
}

.menu-button:hover {
    color: #475569;
}

.dropdown-menu {
    position: absolute;
    right: 0;
    top: 100%;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    padding: 4px 0;
    z-index: 1000;
    min-width: 160px;
    cursor: pointer;
}

.menu-item {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 16px;
    border: none;
    background-color: transparent;
    color: #64748b;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.menu-item.delete {
    color: #dc2626;
}

.menu-item:hover {
    background-color: #f1f5f9;
}

.menu-divider {
    margin: 4px 0;
    border: none;
    border-top: 1px solid #e2e8f0;
}

/* NewsTableHeaderColumns */

/* Table Header Styles */
.table-header {
    text-align: center;
    padding: 12px 16px;
    border-bottom: 2px solid #e5e7eb;
    background-color: #f8fafc;
    color: #475569;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-right: 1px solid #e5e7eb;
    position: sticky;
    top: 0;
    z-index: 10;
    white-space: nowrap;
}

.table-header.checkbox {
    width: 40px;
    min-width: 40px;
    padding: 12px 8px;
}

.table-header.wide {
    width: 280px;
    min-width: 280px;
    padding: 12px 8px;
}

.table-header.full {
    width: 100%;
    min-width: 400px;
}

.table-header.stats {
    width: 280px;
    padding: 12px 24px;
}

.table-header.sortable {
    cursor: pointer;
}

.table-header.sortable:hover {
    background-color: #f1f5f9;
}

.table-header.compact {
    width: 180px;
    min-width: 180px;
    padding: 8px;
}

/* Добавляем стили для колонки Лиды */
.table-header.leads {
    width: 90px;
    min-width: 90px;
    text-align: center;
    cursor: pointer;
    background-color: #f5f6f8;
}

.stats-cell.leads {
    text-align: center;
    font-weight: 600;
    color: #1a73e8;
}

/* Изменяем цвет при наведении для строки заголовка с Лидами */
.table-header.leads:hover {
    background-color: #e8f0fe;
}

/* Table Cell Styles */
.table-cell {
    padding: 12px 16px;
    font-size: 14px;
    color: #475569;
    border-right: 1px solid #e2e8f0;
    white-space: nowrap;
    vertical-align: middle;
    text-align: center;
    height: 100%;
}

.table-cell.wide {
    width: 280px;
    min-width: 280px;
    padding: 12px 8px;
    text-align: left;
}

.table-cell.full {
    width: 100%;
    text-align: left;
}

.table-cell.compact {
    width: 180px;
    min-width: 180px;
    padding: 8px;
    border-right: 1px solid #e2e8f0;
}

.stats-cell {
    padding: 12px 24px;
    font-size: 14px;
    color: #475569;
    border-right: 1px solid #e2e8f0;
    white-space: nowrap;
    vertical-align: middle;
    text-align: center;
}

/* Table Footer Styles */
.table-footer {
    background-color: #f8fafc;
    border-top: 2px solid #e5e7eb;
}

.footer-cell {
    padding: 8px 16px;
    vertical-align: middle;
    border-right: 1px solid #e5e7eb;
    font-size: 14px;
    color: #1e293b;
    font-weight: 600;
    background-color: #f8fafc;
    text-align: center;
}

.footer-cell.right {
    text-align: right;
}

/* Sort Arrows Styles */
.sort-arrows {
    display: flex;
    flex-direction: row;
    margin-left: 4px;
    gap: 2px;
    align-items: center;
}

.sort-arrow {
    font-size: 10px;
    color: #94a3b8;
    cursor: pointer;
    transition: color 0.2s ease;
}

.sort-arrow.active {
    color: #2a5298;
}

/* Stats Display Styles */
.stats-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
}

.stats-row {
    display: flex;
    justify-content: space-between;
    gap: 8px;
}

.stats-details {
    display: flex;
    gap: 12px;
    font-size: 12px;
    color: #6B7280;
}

.stats-details span {
    white-space: nowrap;
}

.stats-period {
    font-weight: 500;
    color: #4B5563;
}

.stats-divider {
    width: 1px;
    height: 16px;
    background-color: #E5E7EB;
    margin: 0 2px;
}

.average-ctr-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.average-ctr-label {
    color: #6B7280;
    font-size: 12px;
}

.ctr-comparison {
    font-weight: 500;
    font-size: 12px;
    display: flex;
    align-items: center;
}

.ctr-comparison::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 6px;
}

.ctr-above-average {
    color: #10B981;
}

.ctr-above-average::before {
    background-color: #10B981;
}

.ctr-below-average {
    color: #EF4444;
}

.ctr-below-average::before {
    background-color: #EF4444;
}

.ctr-average {
    color: #6B7280;
}

.ctr-average::before {
    background-color: #6B7280;
}

/* Header Content Styles */
.table-header-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    white-space: nowrap;
}

/* NewsTitle Styles */
.news-title-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 400px;
    height: 110px;
    justify-content: space-between;
}

.news-title {
    font-size: 20px;
    color: #1e293b;
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 4px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
}

.url-container {
    background-color: #f8fafc;
    border-radius: 6px;
    width: 100%;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    word-wrap: break-word;
    white-space: normal;
}

.url {
    font-size: 11px;
    color: #868686;
    text-decoration: none;
    display: block;
    width: 100%;
    padding: 8px 12px;
    white-space: normal;
    word-break: break-all;
}

.url:hover {
    text-decoration: underline;
    background-color: #f1f5f9;
    border-radius: 6px;
}

/* NewsTableRow Styles */
tr {
    border-bottom: 1px solid #e2e8f0;
}

.hover\\:bg-gray-50:hover {
    background-color: #f9fafb;
}

.opacity-50 {
    opacity: 0.5;
}

.news-content-wrapper {
    display: flex;
    gap: 16px;
    align-items: flex-start;
    width: 100%;
}

.image-container {
    width: 110px;
    height: 110px;
    overflow: hidden;
    border-radius: 8px;
    flex-shrink: 0;
}

.news-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease;
}

.news-image:hover {
    transform: scale(1.05);
}

.checkbox-input {
    width: 16px;
    height: 16px;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.checkbox-input:checked {
    background-color: #3b82f6;
    border-color: #3b82f6;
}

.checkbox-input:hover {
    border-color: #93c5fd;
}

.news-weight-info {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px solid #eee;
}

.weight-bar {
    border-radius: 2px;
    overflow: hidden;
}

.news-reach-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.reach-label {
    font-size: 14px;
    color: #6B7280;
    white-space: nowrap;
}

.reach-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
}

.reach-bar-container {
    width: 100px;
    height: 6px;
    background-color: #E5E7EB;
    border-radius: 3px;
    overflow: hidden;
}

.reach-bar {
    height: 100%;
    background-color: #4CAF50;
    border-radius: 3px;
    transition: width 0.3s ease, background-color 0.3s ease;
}

.reach-percentage {
    font-weight: 600;
    font-size: 14px;
    color: #1F2937;
    min-width: 40px;
}

.reach-description {
    font-size: 12px;
    color: #6B7280;
}

.learning-badge {
    display: inline-block;
    background-color: #EEF2FF;
    color: #6366F1;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    margin-bottom: 4px;
}

.error-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    background-color: #FEE2E2;
    border-radius: 12px;
    font-size: 12px;
    color: #B91C1C;
    font-weight: 500;
}

.stats-details {
    display: flex;
    gap: 12px;
    margin-top: 5px;
    font-size: 12px;
    color: #6B7280;
}

.stats-details span {
    white-space: nowrap;
}

/* Стили для блока среднего CTR */
.average-ctr-info {
    margin-top: 10px;
    padding: 6px 8px;
    background-color: #F3F4F6;
    border-radius: 6px;
    font-size: 12px;
}

.average-ctr-label {
    color: #6B7280;
    display: flex;
    justify-content: space-between;
}

.ctr-comparison {
    margin-top: 4px;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.ctr-comparison::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 6px;
}

.ctr-above-average {
    color: #10B981;
}

.ctr-above-average::before {
    background-color: #10B981;
}

.ctr-below-average {
    color: #EF4444;
}

.ctr-below-average::before {
    background-color: #EF4444;
}

.ctr-average {
    color: #6B7280;
}

.ctr-average::before {
    background-color: #6B7280;
}

/* Стили для контейнера статистики в две колонки */
.news-stats-container {
    width: 100%;
}

.news-stats-columns {
    display: flex;
    gap: 15px;
    width: 100%;
}

.news-stats-column {
    flex: 1 1;
}

.reach-info-block {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.average-stats-info {
    margin-top: 6px;
    font-size: 11px;
    color: #6B7280;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

/* Остальные стили для блоков статистики */
.news-reach-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.reach-top-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.reach-full-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.news-weight-column {
    padding: 4px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-height: 110px;
}

.weight-bar-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 2px;
}

.weight-bar-container {
    flex: 1 1;
    background-color: #f3f4f6;
    border-radius: 2px;
    height: 4px;
}

.weight-percentage {
    font-size: 12px;
    font-weight: 500;
    min-width: 32px;
    color: #666;
}

.weight-description {
    font-size: 11px;
    padding: 2px 6px;
    border-radius: 4px;
    color: #fff;
    display: inline-block;
}

.weight-stats {
    margin-top: 2px;
    padding-top: 4px;
    border-top: 1px solid #f3f4f6;
}

.stats-values {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.ctr-comparison-block {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px solid #f3f4f6;
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.stats-period {
    font-size: 11px;
    color: #64748b;
    margin-bottom: 4px;
    font-weight: 500;
}

.stats-main-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 2px;
}

.stats-value {
    font-size: 12px;
    color: #1e293b;
}

.stats-label {
    font-size: 11px;
    color: #64748b;
}

.stats-item {
    display: flex;
    align-items: center;
    gap: 4px;
}

.stats-ctr {
    font-size: 12px;
    color: #1e293b;
    margin-top: 2px;
}

.loading-state {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 110px;
    width: 100%;
    color: #64748b;
    font-size: 14px;
}

.loading-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.loading-dots-wave {
    display: flex;
    gap: 4px;
    height: 8px;
}

.dot {
    width: 6px;
    height: 6px;
    background-color: #64748b;
    border-radius: 50%;
    animation: wave 1.4s infinite ease-in-out;
}

.dot:nth-child(2) {
    animation-delay: 0.2s;
}

.dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes wave {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-6px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/NewsTableRow.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,uCAAuC;IACvC,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;;AAEA,2BAA2B;;AAE3B,wBAAwB;AACxB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,8DAA8D;AAC9D;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kDAAkD;AAClD;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":["/* ActionButtons Styles */\n.action-column {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 280px;\n    min-width: 280px;\n    padding: 4px;\n}\n\n.action-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    justify-content: flex-start;\n    width: 100%;\n}\n\n.info-row {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    color: #64748b;\n}\n\n.info-label {\n    font-size: 12px;\n    color: #94a3b8;\n}\n\n.info-value {\n    font-size: 12px;\n    color: #1e293b;\n}\n\n.action-link {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 1px;\n    border: none;\n    background-color: transparent;\n    color: #475569;\n    font-size: 13px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.action-link:hover {\n    background-color: #f1f5f9;\n}\n\n.menu-wrapper {\n    position: relative;\n    display: inline-block;\n}\n\n.menu-button {\n    padding: 4px 8px;\n    border: none;\n    background-color: transparent;\n    color: #64748b;\n    cursor: pointer;\n    font-size: 16px;\n    line-height: 1;\n    transition: color 0.2s ease;\n}\n\n.menu-button:hover {\n    color: #475569;\n}\n\n.dropdown-menu {\n    position: absolute;\n    right: 0;\n    top: 100%;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.15);\n    padding: 4px 0;\n    z-index: 1000;\n    min-width: 160px;\n    cursor: pointer;\n}\n\n.menu-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    padding: 8px 16px;\n    border: none;\n    background-color: transparent;\n    color: #64748b;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.menu-item.delete {\n    color: #dc2626;\n}\n\n.menu-item:hover {\n    background-color: #f1f5f9;\n}\n\n.menu-divider {\n    margin: 4px 0;\n    border: none;\n    border-top: 1px solid #e2e8f0;\n}\n\n/* NewsTableHeaderColumns */\n\n/* Table Header Styles */\n.table-header {\n    text-align: center;\n    padding: 12px 16px;\n    border-bottom: 2px solid #e5e7eb;\n    background-color: #f8fafc;\n    color: #475569;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    border-right: 1px solid #e5e7eb;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    white-space: nowrap;\n}\n\n.table-header.checkbox {\n    width: 40px;\n    min-width: 40px;\n    padding: 12px 8px;\n}\n\n.table-header.wide {\n    width: 280px;\n    min-width: 280px;\n    padding: 12px 8px;\n}\n\n.table-header.full {\n    width: 100%;\n    min-width: 400px;\n}\n\n.table-header.stats {\n    width: 280px;\n    padding: 12px 24px;\n}\n\n.table-header.sortable {\n    cursor: pointer;\n}\n\n.table-header.sortable:hover {\n    background-color: #f1f5f9;\n}\n\n.table-header.compact {\n    width: 180px;\n    min-width: 180px;\n    padding: 8px;\n}\n\n/* Добавляем стили для колонки Лиды */\n.table-header.leads {\n    width: 90px;\n    min-width: 90px;\n    text-align: center;\n    cursor: pointer;\n    background-color: #f5f6f8;\n}\n\n.stats-cell.leads {\n    text-align: center;\n    font-weight: 600;\n    color: #1a73e8;\n}\n\n/* Изменяем цвет при наведении для строки заголовка с Лидами */\n.table-header.leads:hover {\n    background-color: #e8f0fe;\n}\n\n/* Table Cell Styles */\n.table-cell {\n    padding: 12px 16px;\n    font-size: 14px;\n    color: #475569;\n    border-right: 1px solid #e2e8f0;\n    white-space: nowrap;\n    vertical-align: middle;\n    text-align: center;\n    height: 100%;\n}\n\n.table-cell.wide {\n    width: 280px;\n    min-width: 280px;\n    padding: 12px 8px;\n    text-align: left;\n}\n\n.table-cell.full {\n    width: 100%;\n    text-align: left;\n}\n\n.table-cell.compact {\n    width: 180px;\n    min-width: 180px;\n    padding: 8px;\n    border-right: 1px solid #e2e8f0;\n}\n\n.stats-cell {\n    padding: 12px 24px;\n    font-size: 14px;\n    color: #475569;\n    border-right: 1px solid #e2e8f0;\n    white-space: nowrap;\n    vertical-align: middle;\n    text-align: center;\n}\n\n/* Table Footer Styles */\n.table-footer {\n    background-color: #f8fafc;\n    border-top: 2px solid #e5e7eb;\n}\n\n.footer-cell {\n    padding: 8px 16px;\n    vertical-align: middle;\n    border-right: 1px solid #e5e7eb;\n    font-size: 14px;\n    color: #1e293b;\n    font-weight: 600;\n    background-color: #f8fafc;\n    text-align: center;\n}\n\n.footer-cell.right {\n    text-align: right;\n}\n\n/* Sort Arrows Styles */\n.sort-arrows {\n    display: flex;\n    flex-direction: row;\n    margin-left: 4px;\n    gap: 2px;\n    align-items: center;\n}\n\n.sort-arrow {\n    font-size: 10px;\n    color: #94a3b8;\n    cursor: pointer;\n    transition: color 0.2s ease;\n}\n\n.sort-arrow.active {\n    color: #2a5298;\n}\n\n/* Stats Display Styles */\n.stats-container {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 100%;\n}\n\n.stats-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n}\n\n.stats-details {\n    display: flex;\n    gap: 12px;\n    font-size: 12px;\n    color: #6B7280;\n}\n\n.stats-details span {\n    white-space: nowrap;\n}\n\n.stats-period {\n    font-weight: 500;\n    color: #4B5563;\n}\n\n.stats-divider {\n    width: 1px;\n    height: 16px;\n    background-color: #E5E7EB;\n    margin: 0 2px;\n}\n\n.average-ctr-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.average-ctr-label {\n    color: #6B7280;\n    font-size: 12px;\n}\n\n.ctr-comparison {\n    font-weight: 500;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n}\n\n.ctr-comparison::before {\n    content: \"\";\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    margin-right: 6px;\n}\n\n.ctr-above-average {\n    color: #10B981;\n}\n\n.ctr-above-average::before {\n    background-color: #10B981;\n}\n\n.ctr-below-average {\n    color: #EF4444;\n}\n\n.ctr-below-average::before {\n    background-color: #EF4444;\n}\n\n.ctr-average {\n    color: #6B7280;\n}\n\n.ctr-average::before {\n    background-color: #6B7280;\n}\n\n/* Header Content Styles */\n.table-header-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    white-space: nowrap;\n}\n\n/* NewsTitle Styles */\n.news-title-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-width: 400px;\n    height: 110px;\n    justify-content: space-between;\n}\n\n.news-title {\n    font-size: 20px;\n    color: #1e293b;\n    font-weight: 600;\n    line-height: 1.4;\n    margin-bottom: 4px;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    white-space: normal;\n}\n\n.url-container {\n    background-color: #f8fafc;\n    border-radius: 6px;\n    width: 100%;\n    border: 1px solid #e2e8f0;\n    overflow: hidden;\n    word-wrap: break-word;\n    white-space: normal;\n}\n\n.url {\n    font-size: 11px;\n    color: #868686;\n    text-decoration: none;\n    display: block;\n    width: 100%;\n    padding: 8px 12px;\n    white-space: normal;\n    word-break: break-all;\n}\n\n.url:hover {\n    text-decoration: underline;\n    background-color: #f1f5f9;\n    border-radius: 6px;\n}\n\n/* NewsTableRow Styles */\ntr {\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.hover\\:bg-gray-50:hover {\n    background-color: #f9fafb;\n}\n\n.opacity-50 {\n    opacity: 0.5;\n}\n\n.news-content-wrapper {\n    display: flex;\n    gap: 16px;\n    align-items: flex-start;\n    width: 100%;\n}\n\n.image-container {\n    width: 110px;\n    height: 110px;\n    overflow: hidden;\n    border-radius: 8px;\n    flex-shrink: 0;\n}\n\n.news-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.2s ease;\n}\n\n.news-image:hover {\n    transform: scale(1.05);\n}\n\n.checkbox-input {\n    width: 16px;\n    height: 16px;\n    border: 1px solid #cbd5e1;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.checkbox-input:checked {\n    background-color: #3b82f6;\n    border-color: #3b82f6;\n}\n\n.checkbox-input:hover {\n    border-color: #93c5fd;\n}\n\n.news-weight-info {\n    margin-top: 4px;\n    padding-top: 4px;\n    border-top: 1px solid #eee;\n}\n\n.weight-bar {\n    border-radius: 2px;\n    overflow: hidden;\n}\n\n.news-reach-info {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.reach-label {\n    font-size: 14px;\n    color: #6B7280;\n    white-space: nowrap;\n}\n\n.reach-indicator {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.reach-bar-container {\n    width: 100px;\n    height: 6px;\n    background-color: #E5E7EB;\n    border-radius: 3px;\n    overflow: hidden;\n}\n\n.reach-bar {\n    height: 100%;\n    background-color: #4CAF50;\n    border-radius: 3px;\n    transition: width 0.3s ease, background-color 0.3s ease;\n}\n\n.reach-percentage {\n    font-weight: 600;\n    font-size: 14px;\n    color: #1F2937;\n    min-width: 40px;\n}\n\n.reach-description {\n    font-size: 12px;\n    color: #6B7280;\n}\n\n.learning-badge {\n    display: inline-block;\n    background-color: #EEF2FF;\n    color: #6366F1;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    margin-bottom: 4px;\n}\n\n.error-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 8px;\n    background-color: #FEE2E2;\n    border-radius: 12px;\n    font-size: 12px;\n    color: #B91C1C;\n    font-weight: 500;\n}\n\n.stats-details {\n    display: flex;\n    gap: 12px;\n    margin-top: 5px;\n    font-size: 12px;\n    color: #6B7280;\n}\n\n.stats-details span {\n    white-space: nowrap;\n}\n\n/* Стили для блока среднего CTR */\n.average-ctr-info {\n    margin-top: 10px;\n    padding: 6px 8px;\n    background-color: #F3F4F6;\n    border-radius: 6px;\n    font-size: 12px;\n}\n\n.average-ctr-label {\n    color: #6B7280;\n    display: flex;\n    justify-content: space-between;\n}\n\n.ctr-comparison {\n    margin-top: 4px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n}\n\n.ctr-comparison::before {\n    content: \"\";\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    margin-right: 6px;\n}\n\n.ctr-above-average {\n    color: #10B981;\n}\n\n.ctr-above-average::before {\n    background-color: #10B981;\n}\n\n.ctr-below-average {\n    color: #EF4444;\n}\n\n.ctr-below-average::before {\n    background-color: #EF4444;\n}\n\n.ctr-average {\n    color: #6B7280;\n}\n\n.ctr-average::before {\n    background-color: #6B7280;\n}\n\n/* Стили для контейнера статистики в две колонки */\n.news-stats-container {\n    width: 100%;\n}\n\n.news-stats-columns {\n    display: flex;\n    gap: 15px;\n    width: 100%;\n}\n\n.news-stats-column {\n    flex: 1;\n}\n\n.reach-info-block {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.average-stats-info {\n    margin-top: 6px;\n    font-size: 11px;\n    color: #6B7280;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n/* Остальные стили для блоков статистики */\n.news-reach-info {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.reach-top-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.reach-full-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.news-weight-column {\n    padding: 4px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-height: 110px;\n}\n\n.weight-bar-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 2px;\n}\n\n.weight-bar-container {\n    flex: 1;\n    background-color: #f3f4f6;\n    border-radius: 2px;\n    height: 4px;\n}\n\n.weight-percentage {\n    font-size: 12px;\n    font-weight: 500;\n    min-width: 32px;\n    color: #666;\n}\n\n.weight-description {\n    font-size: 11px;\n    padding: 2px 6px;\n    border-radius: 4px;\n    color: #fff;\n    display: inline-block;\n}\n\n.weight-stats {\n    margin-top: 2px;\n    padding-top: 4px;\n    border-top: 1px solid #f3f4f6;\n}\n\n.stats-values {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.ctr-comparison-block {\n    margin-top: 4px;\n    padding-top: 4px;\n    border-top: 1px solid #f3f4f6;\n    font-size: 11px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.stats-period {\n    font-size: 11px;\n    color: #64748b;\n    margin-bottom: 4px;\n    font-weight: 500;\n}\n\n.stats-main-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 2px;\n}\n\n.stats-value {\n    font-size: 12px;\n    color: #1e293b;\n}\n\n.stats-label {\n    font-size: 11px;\n    color: #64748b;\n}\n\n.stats-item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.stats-ctr {\n    font-size: 12px;\n    color: #1e293b;\n    margin-top: 2px;\n}\n\n.loading-state {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 110px;\n    width: 100%;\n    color: #64748b;\n    font-size: 14px;\n}\n\n.loading-text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n}\n\n.loading-dots-wave {\n    display: flex;\n    gap: 4px;\n    height: 8px;\n}\n\n.dot {\n    width: 6px;\n    height: 6px;\n    background-color: #64748b;\n    border-radius: 50%;\n    animation: wave 1.4s infinite ease-in-out;\n}\n\n.dot:nth-child(2) {\n    animation-delay: 0.2s;\n}\n\n.dot:nth-child(3) {\n    animation-delay: 0.4s;\n}\n\n@keyframes wave {\n    0%, 100% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(-6px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
